<div class="flex justify-center my-10 px-5 md:px-12 lg:px-27 text-center text-text-primary">
    <div class="flex flex-col w-full sm:w-98">
        <ng-container *ngIf="!subscribedToNews">
            <h2 class="h2-text" i18n>Stay tuned for updates</h2>
            <p class="body-m-text my-4" i18n>Subscribe to get notified about our launch</p>
        </ng-container>
        <ng-container *ngIf="subscribedToNews">
            <h2 class="h2-text" i18n>Thank you!</h2>
            <p class="body-m-text my-4" i18n>More updates coming soon!</p>
        </ng-container>

        <form [formGroup]="subscriberForm" (ngSubmit)="subscribe()">
            <mat-form-field class="w-full">
                <input matInput i18n-placeholder placeholder="Your email" formControlName="subscriberEmail"/>                
            </mat-form-field>

            <button *ngIf="!subscribedToNews" class="primary-button w-full" type="submit" i18n>Subscribe</button>
            <div *ngIf="subscribedToNews">
                <button class="base-button bg-transparent flex justify-center items-center text-accent-green w-full gap-2" type="button">
                    <mat-icon>check</mat-icon>
                    <span i18n>Subscribed!</span>
                </button>
                <button class="mt-2 secondary-button w-full" type="button" routerLink="/home" i18n>Back to home page</button>
            </div>
            
        </form>
    </div>
</div>